// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import PassbookChequeDetailsActionType from './passbook-cheque-details.types';

const INITIAL_STATE = {
	passbookChequeIDType: null,
	passbookChequeImage: null,
	updatePassbookChequeResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** PassbookCheque Update Start ************************/
		case PassbookChequeDetailsActionType.UPDATE_PASSBOOK_CHEQUE_SUCCESS:
			return { ...state, updatePassbookChequeResponse: action.payload };

		case PassbookChequeDetailsActionType.UPDATE_PASSBOOK_CHEQUE_FAILURE:
			return { ...state, updatePassbookChequeResponse: action.payload };

		case PassbookChequeDetailsActionType.UPDATE_PASSBOOK_CHEQUE_RESPONSE_CHANGED:
			return { ...state, updatePassbookChequeResponse: null };

		/** ***************** PassbookCheque Update End ************************/
		default:
			return state;
	}
};
